<template>
  <div v-if="paginationDetails.resultsExist" style="margin-top: 1.25rem">
    <div class="row pagination">
      <div class="pagination-total-count">
        <div class="total-count">
          Showing {{ paginationDetails.startCount }} - {{ paginationDetails.endCount }} of
          {{ paginationDetails.totalCount }}
        </div>
      </div>
    </div>
    <div v-if="!showOnlyResultCount" class="row pagination-buttons">
      <a class="pagination-item" @click="$emit('update', paginationDetails.previousPage)">
        <button class="small-button" style="margin: 0" :disabled="!paginationDetails.previousPage">
          Previous page
        </button>
      </a>
      <a class="pagination-item" @click="$emit('update', paginationDetails.nextPage)">
        <button class="small-button" style="margin: 0" :disabled="!paginationDetails.nextPage">
          Next page
        </button>
      </a>
    </div>
    <div v-if="!showOnlyResultCount && !hidePages" class="row pagination-numbers">
      <a
        v-for="(page, index) in paginationDetails.totalPages"
        :key="index"
        :class="{ 'has-text-cf-orange': page === paginationDetails.currentPage }"
        class="pagination-number"
        @click="$emit('update', page)"
        >{{ page }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    showOnlyResultCount: {
      type: Boolean,
      default: false,
    },
    hidePages: {
      type: Boolean,
      default: false,
    },
    paginationDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  methods: {
    //   Need to fix this to show the last 15 numbers
    largerThanFifteen(number) {
      if (number > 15) {
        return 15
      } else {
        return number
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/buttons';
@import '../styles/layout';
@import '../styles/mixins/fontcolors';

.pagination {
  display: flex;
  padding: 0 1.25rem;
}
.pagination-numbers {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 0 1rem 0.75rem;
}
.pagination-total-count {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 1.25rem;
}
.pagination-buttons {
  flex: 1;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.pagination-numbers {
  margin-top: 1rem;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  justify-content: flex-start;
}
.pagination-number {
  padding: 0.25rem 0.5rem;
}

.pagination-previous {
}
.pagination-next {
}

.is-current {
  color: blue;
}
.element {
  margin: 10px 0;
}
.box {
  margin: 10px 0;
}
</style>
